/**
 * [ File :: G_ImageHitItem.js ]
 *
 * @경로 : /public/scripts/game/lcPlugIn/canvas/grid/dev/child/image/G_ImageHitItem.js
 * @설명 : 부딪혀서 획득하는 아이템 객체
 * @진행 : 종료
 * @주의 : "hitItem 메소드"는 "moveForward 메소드"의 사후처리로 진행됩니다.
 * @일자 : 2018.mm.dd
 * @작성 : SuperMoon
 * @참조 :
 */

import G_ImageGrid from 'canvas/grid/dev/child/image/G_ImageGrid';

const G_ImageHitItem = (function() {

	return class extends G_ImageGrid {
		constructor(obj) { super(obj); }

		/**
		 * [ Function (public) :: hitHero ]
		 *
		 * @DES :: 아이템(히트)이 캐릭터(영웅)와 만났을 때 함수
		 * @IP1 :: cb {func}
		 */
		hitHero(cb) {
			let LIST = LC.WORLD.LIST;
			LIST.hitItem.forEach((iv) => {
				if(iv.getEnable()) {
					list.hero.forEach((hv) => {
						if(iv.getGridX() == hv.getGridX() && iv.getGridY() == hv.getGridY()) {
							iv.setEnable(false);
							LC.getEffect().motionDelete('centerToTop', iv, function() {
								iv.remove();
								if(cb) cb();
							});
						}
					});
				}
			});
		}

	}
}());

export default G_ImageHitItem;


// WEBPACK FOOTER //
// ./src/assets/js/codmos/game/lcPlugIn/canvas/grid/dev/child/image/G_ImageHitItem.js